import * as Ariakit from '@ariakit/react'
import * as React from 'react'

import { Dialog, useDialogState } from '../../../../components/dialog'
import { Spinner } from '../../../../components/spinner'
import { useAsyncModule } from '../../../../services/async-modules-utils'
import { createAlertAsyncModule } from '../../../create-alert/async-modules'
import { QuoteContext } from '../../QuoteContext'
import { NavigationLink } from './QuoteLinkComponent'

export function CreateAlertLink() {
  const { ticker } = React.useContext(QuoteContext)
  const dialog = useDialogState()
  const isVisible = Ariakit.useStoreState(dialog, 'open')

  const [createAlertModule] = useAsyncModule({
    ...createAlertAsyncModule,
    shouldLoadModule: isVisible,
  })
  const CreateAlert = createAlertModule?.CreateAlert

  return (
    <>
      <NavigationLink
        isEliteOnly
        utmCampaign="quote-create-alert"
        getLink={() => `/create_alert.ashx?t=${ticker}`}
        onClick={(e) => {
          if (!FinvizSettings.hasUserPremium) return
          window.gtag?.('event', 'click', { event_category: 'create-alert' })
          if (e.ctrlKey || e.metaKey) return
          e.preventDefault() // needed to prevent opening parent link
          dialog.show()
        }}
        data-testid="set-alert-link"
      >
        Set Alert
      </NavigationLink>
      <Dialog state={dialog} aria-label="Set Alert" className="w-[366px]">
        {CreateAlert ? (
          <CreateAlert ticker={ticker} />
        ) : (
          <div className="flex h-96 items-center justify-center">
            <Spinner />
          </div>
        )}
      </Dialog>
    </>
  )
}
